//
// Shop: Search
//

"use strict";

( function($, waTheme) {

    var Search = (function ($) {

        Search = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$form = that.$wrapper.find(".b-search__form");
            that.$formInput = that.$wrapper.find(".b-search__input");
            that.$actionDropdown = that.$wrapper.find(".b-search__app-dropdown");
            that.$actionItems = that.$wrapper.find(".js-search-change-action");
            that.$formInputClear = that.$wrapper.find(".js-search-clear");
            that.$formDropdownMenu = that.$wrapper.find(".b-search__dropdown-menu");
            that.$formDropdownSubmit = that.$wrapper.find(".js-search-submit");

            //
            that.$mobileFormCanvas = that.$wrapper.find(".b-search__offcanvas");

            // VARS
            that.min_length = 3;

            // DYNAMIC VARS
            that.app = that.$form.data("app");
            that.is_locked = false;

            // INIT
            that.init();
        };

        Search.prototype.init = function () {
            var that = this;

            that.$actionItems.on("click", function () {
                var app = $(this).data("app"),
                    action = $(this).data("action"),
                    text = $(this).text();

                if (action) {
                    that.app = app;
                    that.$form.attr("action", action);
                    that.$actionDropdown.text(text);
                }
            });

            that.$formInput.on("change, keyup", function () {
                var input_length = $(this).val().length;

                if (input_length && that.app === "shop") {
                    that.$formInputClear.removeClass("is-hidden");
                    if (input_length >= that.min_length && that.is_locked === false) {
                        that.getProducts();
                    }
                } else {
                    that.$formInputClear.addClass("is-hidden");
                }
            });

            that.$formInputClear.on("click", function () {
                that.$formInput.val("");
                that.$formInputClear.addClass("is-hidden");
                that.$formDropdownMenu.removeClass("show");
            });

            // outside click
            $(window).on('click', function (event) {
                if (that.$formDropdownMenu.has(event.target).length === 0 && !that.$formDropdownMenu.is(event.target)) {
                    that.$formDropdownMenu.removeClass("show");
                }
            });

            that.$formDropdownSubmit.on("click", function () {
                that.$form.submit();
            });

            // Custom opener
            $(".js-mobile-search-toggle").on("click", function () {
                that.$mobileFormCanvas.offcanvas("toggle");
            });
        };

        Search.prototype.getProducts = function () {
            var that = this,
                action = that.$form.attr('action'),
                input_text = that.$formInput.val(),
                html = "";

            that.$formDropdownMenu.removeClass("show");

            //
            // that.is_locked = true;

            $.get(`${action}?query=${encodeURIComponent(input_text)}`, function (data) {
                var $products = $(data).find('.s-product-wrapper');

                if ($products.length > 0) {

                    $products.each(function () {
                        var href = $(this).find(".b-products-images__wrapper").attr('href'),
                            image = $(this).find(".b-products-images__image.active").html(),
                            name = $(this).find(".s-product-header").html(),
                            price = $(this).find(".b-products-price").html();

                        html += `
                            <a class="b-search__product d-flex gap-4 link-emphasis" href="${href}">
                                <div class="b-search__product-image">
                                    ${image}
                                </div>
                                <div class="b-search__product-content">
                                    <div class="b-search__product-name">${name}</div>
                                    <div class="b-search__product-price text-dark">${price}</div>
                                </div>
                            </a>
                        `;
                    });

                    that.$formDropdownMenu.find(".b-search__product").remove();
                    that.$formDropdownMenu.find(".b-search__dropdown-menu-products").prepend(html);
                    that.$formDropdownMenu.addClass("show");

                    waTheme.init.site.ImageLazyLoad.update();
                }
            });

            //
            that.is_locked = false;
        };

        return Search;

    })($);

    waTheme.init.shop.Search = Search;

    var $wrapper = $('.b-search:not(.b-search-pro)');
    if ($wrapper.length) {
        $wrapper.each(function () {
            new window.waTheme.init.shop.Search({
                $wrapper: $(this),
            });
        });
    }

})(jQuery, window.waTheme);
